import { render, staticRenderFns } from "./viewTicket.vue?vue&type=template&id=22ff2b04&scoped=true&"
import script from "./viewTicket.vue?vue&type=script&lang=js&"
export * from "./viewTicket.vue?vue&type=script&lang=js&"
import style0 from "./viewTicket.vue?vue&type=style&index=0&id=22ff2b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff2b04",
  null
  
)

export default component.exports